import { BrowserModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { CameraPreview } from '@ionic-native/camera-preview';
import { PhotoLibrary } from '@ionic-native/photo-library';
import { Keyboard } from '@ionic-native/keyboard';
import { KeysPipe } from '../pipes/keys/keys';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { Screenshot } from '@ionic-native/screenshot/ngx';
import { SocialSharing } from '@ionic-native/social-sharing';
import { Camera } from '@ionic-native/camera';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IonicStorageModule } from '@ionic/storage';
import { MyApp } from './app.component';
import { MainPage } from '../pages/main/main';
import { TutorialPage } from '../pages/tutorial/tutorial';
import { LoginPage } from '../pages/login/login';
import { SignupPage } from '../pages/signup/signup';
import { ForgotPage } from '../pages/forgot/forgot';
import { LoadingPage } from '../pages/loading/loading';
import { ColorsPopoverPage } from '../pages/colors-popover/colors-popover'
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { IonicSelectableModule } from 'ionic-selectable';
import { Base64 } from '@ionic-native/base64';
import fb from 'firebase/app';
import 'firebase/firestore';

var firebaseConfig = {
  apiKey: "AIzaSyBkP-25mvNCGxAlPDAI3hlgjjH8nCS2leg",
  authDomain: "overlapp-estudiocactus.firebaseapp.com",
  databaseURL: "https://overlapp-estudiocactus.firebaseio.com",
  projectId: "overlapp-estudiocactus",
  storageBucket: "overlapp-estudiocactus.appspot.com",
  messagingSenderId: "887868962047",
  appId: "1:887868962047:web:d4a8d18905c9471dee48ca",
  measurementId: "G-PFZKR18ZRG"
};
fb.initializeApp(firebaseConfig)

export class HammerConfigExt extends HammerGestureConfig {
  overrides = {
    'pinch': { enabled: true },
    "pan": { direction: 30 },
    'rotate': { enable: true }
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    MyApp,
    MainPage,
    TutorialPage,
    ColorsPopoverPage,
    KeysPipe,
    LoginPage,
    SignupPage,
    ForgotPage,
    LoadingPage
  ],
  imports: [
    IonicSelectableModule,
    BrowserModule,
    IonicModule.forRoot(MyApp, {
      tabsPlacement: 'top',
      backButtonText: '',
      mode: 'ios'
    }),
    HttpClientModule,
    IonicStorageModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    MainPage,
    TutorialPage,
    ColorsPopoverPage,
    LoginPage,
    SignupPage,
    ForgotPage,
    LoadingPage
  ],
  providers: [
    Base64,
    InAppBrowser,
    StatusBar,
    SplashScreen,
    ScreenOrientation,
    CameraPreview,
    PhotoLibrary,
    Screenshot,
    SocialSharing,
    Camera,
    Keyboard,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerConfigExt
    }
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts